import React from "react";
import { Info, RefreshCw } from "lucide-react";

function WebhookError({error,onRetry,}) {
  return (
    <div className="min-w-0">
      <div className="rounded-[22px] border border-[#efcecc] bg-white p-5 shadow-[0_16px_44px_rgba(15,43,66,0.06)] dark:border-[#603d3b] dark:bg-[#211b19]">
          <div className="flex items-start gap-3">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-red-50 text-red-500">
              <Info size={16} />
            </div>
            <div className="flex-1">
              <h3 className="text-[11px] font-semibold text-slate-800">
                Unable to load webhook
              </h3>
              <p className="mt-1 text-[10px] leading-4 text-slate-400">
                {error}
              </p>
              <button
                type="button"
                onClick={onRetry}
                className="mt-4 flex h-9 items-center gap-2 rounded-xl bg-[#147db5] px-3.5 text-[10px] font-bold text-white transition hover:bg-[#0f5b8a] dark:bg-dark-primary dark:hover:bg-dark-primary-hover"
              >
                <RefreshCw size={12} />
                Try Again
              </button>
            </div>
          </div>
      </div>
    </div>
  );
}

export default WebhookError;
